import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  & .hamburger {
    font: inherit;
    display: inline-block;
    overflow: visible;
    margin: 0;
    padding: 5px;
    cursor: pointer;
    transition-timing-function: linear;
    transition-duration: .15s;
    transition-property: opacity,filter;
    text-transform: none;
    color: inherit;
    border: 0;
    background-color: transparent;
  }
  & .hamburger-box {
    position: relative;
    display: inline-block;
    width: 24px;
    height: 20px;
  }
  & .hamburger-inner {
    top: 50%;
    display: block;
    margin-top: -2px;
  }
  & .hamburger--squeeze .hamburger-inner {
    transition-timing-function: cubic-bezier(.55,.055,.675,.19);
    transition-duration: 75ms;
  }
  // before and after
  & .hamburger-inner, & .hamburger-inner:after, & .hamburger-inner:before {
    position: absolute;
    width: 24px;
    height: 2px;
    transition-timing-function: ease;
    transition-duration: .15s;
    transition-property: transform;
    border-radius: 4px;
    background-color: black;
  }
  & .hamburger-inner:after, & .hamburger-inner:before {
    display: block;
    content: "";
  }

  // before
  & .hamburger-inner:before {
    top: -7px;
  }
  & .hamburger--squeeze .hamburger-inner:before {
    transition: top 75ms ease .12s,opacity 75ms ease;
  }

  // after
  & .hamburger-inner:after {
    bottom: -7px;
  }
  & .hamburger--squeeze .hamburger-inner:after {
    transition: bottom 75ms ease .12s,transform 75ms cubic-bezier(.55,.055,.675,.19);
  }

  // .is-active
  & .hamburger--squeeze.is-active .hamburger-inner {
    transition-delay: .12s;
    transition-timing-function: cubic-bezier(.215,.61,.355,1);
    transform: rotate(45deg);
  }

  & .hamburger--squeeze.is-active .hamburger-inner:before {
    top: 0;
    transition: top 75ms ease,opacity 75ms ease .12s;
    opacity: 0;
  }

  & .hamburger.is-active .hamburger-inner:before {
    background-color: black;
  }

  & .hamburger--squeeze.is-active .hamburger-inner:after {
    bottom: 0;
    transition: bottom 75ms ease,transform 75ms cubic-bezier(.215,.61,.355,1) .12s;
    transform: rotate(-90deg);
  }

  & .hamburger.is-active .hamburger-inner:after {
    background-color: black;
}

`;

function HamburgerButton({ isActive, onClick }) {
  return (
    <Wrap onClick={onClick}>
      <div className={`hamburger hamburger--squeeze js-hamburger ${isActive ? 'is-active' : ''}`}>
        <div className="hamburger-box">
          <div className="hamburger-inner" />
        </div>
      </div>
    </Wrap>
  );
}

export default HamburgerButton;
